import { Menu } from '../models/menu.model';

export const MENU: Array<Menu> = [
  {
    icon: 'dashboard',
    route: '/dashboard',
    title: 'Dashboard',
  },
  {
    icon: 'checklist',
    title: 'Checklist',
    rolesCanAccess: ['admin', 'sudo'],
    children: [
      {
        icon: 'category',
        route: 'inspection-types',
        title: 'Tipos de checklist',
      },
      {
        icon: 'settings',
        route: 'checklists',
        title: 'Configuración'
      }
    ]
  }
];

export const COMPANIES_MENU: Array<Menu> = [
  {
    icon: 'dashboard',
    route: 'inspections',
    title: 'Dashboard',
    rolesCanAccess: ['admin', 'sudo'],
  },
  {
    icon: 'precision_manufacturing',
    route: 'machines',
    title: 'Maquinarias',
  },
  {
    icon: 'category',
    route: 'machine-types',
    title: 'Tipos de maquinaria',
    rolesCanAccess: ['admin', 'sudo'],
  },
  {
    icon: 'engineering',
    route: 'operators',
    title: 'Operadores',
    rolesCanAccess: ['admin', 'sudo'],
  },
  {
    icon: 'checklist',
    route: 'inspections',
    title: 'Inspecciones',
    rolesCanAccess: ['admin', 'sudo'],
  },
  // {
  //   icon: 'checklist',
  //   title: 'Checklist',
  //   children: [
  //     {
  //       icon: 'category',
  //       route: 'inspection-types',
  //       title: 'Tipos de checklist',
  //     },
  //     {
  //       icon: 'settings',
  //       route: 'checklists',
  //       title: 'Configuración'
  //     }
  //   ]
  // },
];
